import '../styles/PageGlobal.css';
import './BonDeComFournisseurListPage.css';
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import { BCFService } from '../services/BCFService.js';
import { WorkFlowService } from '../services/WorkFlowService.js';

export default function BonDeComFournisseurListPage() {
  const navigate = useNavigate();
  const bcfService = useMemo(() => new BCFService(), []);
  const workflowService = useMemo(() => new WorkFlowService(), []);
  
  const [lines, setLines] = useState([]);
  const [orphanedLines, setOrphanedLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showAttachModal, setShowAttachModal] = useState(false);
  const [selectedOrphanIds, setSelectedOrphanIds] = useState([]);
  const [availableBcfs, setAvailableBcfs] = useState([]);
  const [selectedBcfId, setSelectedBcfId] = useState("");

  //  SOLUTION ULTIME : Une Ref pour toujours avoir la valeur à jour, sans problème de closure React
  const selectedOrphanIdsRef = useRef([]);

  // Synchroniser la Ref avec le State à chaque fois que le State change
  useEffect(() => {
    selectedOrphanIdsRef.current = selectedOrphanIds;
  }, [selectedOrphanIds]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await bcfService.findAll();
        setLines(data || []);
        const orphans = await bcfService.getOrphanedLines();
        setOrphanedLines(orphans || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [bcfService]);

  const handleToggleSelectOne = (lineId) => {
    const strId = String(lineId);
    setSelectedOrphanIds(prev => {
      if (prev.includes(strId)) {
        return prev.filter(id => id !== strId);
      } else {
        return [...prev, strId];
      }
    });
  };

  const handleToggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrphanIds(orphanedLines.map(line => String(line.id)));
    } else {
      setSelectedOrphanIds([]);
    }
  };

  const handleSyncAllClosedAchat = async () => {
    if (!window.confirm("Transformer TOUTES les lignes d'achat clôturées en lignes BCF orphelines ?")) return;
    try {
      const message = await workflowService.syncAllClosedAchatLines();
      alert(message);
      const data = await bcfService.findAll();
      setLines(data || []);
      const orphans = await bcfService.getOrphanedLines();
      setOrphanedLines(orphans || []);
    } catch (err) {
      alert("Erreur : " + err.message);
    }
  };

  const handleSyncAllClosedAppro = async () => {
    if (!window.confirm("Transformer TOUS les approvisionnements clôturés en nouveaux BCF complets ?")) return;
    try {
      const message = await workflowService.syncAllClosedApprovisionnementLines();
      alert(message);
      const data = await bcfService.findAll();
      setLines(data || []);
    } catch (err) {
      alert("Erreur : " + err.message);
    }
  };

const handleOpenAttachModal = async () => {
    if (orphanedLines.length === 0) {
      alert("Aucune ligne orpheline à attacher.");
      return;
    }
    try {
      const allBcfs = await bcfService.findAll();
      const drafts = allBcfs.filter(b => b.status !== 'CLOSED');
      if (drafts.length === 0) {
        alert("Aucun BCF en brouillon disponible. Créez d'abord un BCF.");
        return;
      }
      setAvailableBcfs(drafts);
      setSelectedBcfId(String(drafts[0].id)); 
      setShowAttachModal(true);
    } catch (err) {
      alert("Erreur : " + err.message);
    }
};

  const handleConfirmAttach = async () => {
    // 🟢 On lit la valeur depuis la Ref, qui est GARANTIE d'être à jour
    const currentIds = selectedOrphanIdsRef.current;
    
   

    if (!selectedBcfId || String(selectedBcfId).trim() === "" || currentIds.length === 0) {
      alert("Veuillez sélectionner un BCF de destination et cocher au moins une ligne.");
      return;
    }
    
    try {
      await bcfService.addLines(selectedBcfId, currentIds);
      alert("Lignes orphelines attachées au BCF avec succès !");
      setShowAttachModal(false);
      
      const data = await bcfService.findAll();
      setLines(data || []);
      const orphans = await bcfService.getOrphanedLines();
      setOrphanedLines(orphans || []);
    } catch (err) {
      alert("Erreur : " + err.message);
    }
  };

  const handleEnvoiFournisseur = async (bcfId) => {
    if (!window.confirm("Confirmer l'envoi et la clôture de ce bon de commande au fournisseur ?")) return;
    try {
      await bcfService.close(bcfId);
      alert("Bon de commande envoyé et clôturé avec succès !");
      const data = await bcfService.findAll();
      setLines(data || []);
    } catch (err) {
      alert("Erreur envoi : " + err.message);
    }
  };

  const handleDownloadPdf = async (bcfId) => {
  try {
    await bcfService.downloadPdf(bcfId);
  } catch (err) {
    alert("Erreur téléchargement PDF : " + err.message);
  }
};

  if (loading) return <div className="devis-status devis-status-loading">Chargement…</div>;
  if (error) return <div className="devis-status devis-status-error">{error}</div>;

  return (
    <div className="containerMain boncomfournisseur-container">
      <h1 className="boncomfournisseur-title">Liste des bons de commande fournisseurs</h1>

      <div style={{ marginBottom: "20px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
        <div style={{ display: 'flex', gap: '15px' }}>
          <ReferenceButton onClick={handleSyncAllClosedAchat}>
            🔄 Synchroniser les ACHATS clôturés
          </ReferenceButton>
          <ReferenceButton onClick={handleSyncAllClosedAppro}>
            🔄 Synchroniser les ACHATS EN DIRECT clôturés
          </ReferenceButton>
        </div>
        
        <ReferenceButton 
          onClick={() => navigate('/bon_com_fournisseur_new')} 
          style={{ backgroundColor: '#28a745', color: 'white', fontWeight: 'bold' }}
        >
          ➕ Nouveau Bon de Commande Fournisseur
        </ReferenceButton>
      </div>

      <div className="boncomfournisseur-table-wrapper">
        <h3>Bons de Commande Fournisseur</h3>
        <div className="table-scroll-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <table className="boncomfournisseur-table">
            <thead>
              <tr>
                <th>ID</th><th>Référence</th><th>Fournisseur ID</th><th>Achat en direct ID</th><th>Statut</th><th>Total Lignes</th><th>Action</th><th>Envoi</th>
              </tr>
            </thead>
            <tbody>
              {lines.length === 0 ? (
                <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>Aucun bon de commande trouvé.</td></tr>
              ) : (
                lines.map(line => (
                  <tr key={line.id}>
                    <td>{line.id}</td>
                    <td>{line.reference || `BCF-${line.id}`}</td>
                    <td>{line.supplierId || 'N/A'}</td>
                    <td>{line.approvisionnementId || 'N/A'}</td>
                    <td>
                      <span style={{ color: line.status === 'CLOSED' ? 'red' : 'green', fontWeight: 'bold' }}>
                        {line.status || 'DRAFT'}
                      </span>
                    </td>
                    <td>{line.lines ? line.lines.length : 0}</td>
                    <td>
                      <button className="boncomfournisseur-btn boncomfournisseur-btn-yellow" onClick={() => navigate(`/bon_com_fournisseur_edit/${line.id}`)}>
                        Détails / Edit
                      </button>
                    </td>
                    <td>
  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

    <button
      className="boncomfournisseur-btn boncomfournisseur-btn-pdf"
      onClick={() => handleDownloadPdf(line.id)}
    >
      📄 PDF
    </button>

    <button
      className="boncomfournisseur-btn boncomfournisseur-btn-blue"
      onClick={() => handleEnvoiFournisseur(line.id)}
      disabled={line.status === 'CLOSED'}
    >
      Envoyer
    </button>

  </div>
</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="boncomfournisseur-table-wrapper" style={{ marginTop: "40px" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h3>Lignes BCF Orphelines (en attente d'attachement)</h3>
          <button className="boncomfournisseur-btn boncomfournisseur-btn-blue" onClick={handleOpenAttachModal} disabled={selectedOrphanIds.length === 0}>
            📎 Attacher au BCF ({selectedOrphanIds.length})
          </button>
        </div>
        <table className="boncomfournisseur-table">
          <thead>
            <tr>
              <th style={{ width: '40px', textAlign: 'center' }}>
                <input 
                  type="checkbox" 
                  checked={orphanedLines.length > 0 && selectedOrphanIds.length === orphanedLines.length} 
                  onChange={handleToggleSelectAll} 
                  title="Tout sélectionner" 
                />
              </th>
              <th>ID Ligne</th><th>Référence</th><th>Ref. Fabricant</th><th>Quantité</th><th>Origine</th>
            </tr>
          </thead>
          <tbody>
            {orphanedLines.length === 0 ? (
              <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>Aucune ligne orpheline en attente.</td></tr>
            ) : (
              orphanedLines.map(line => (
                <tr key={line.id}>
                  <td style={{ textAlign: 'center' }}>
                    <input 
                      type="checkbox" 
                      checked={selectedOrphanIds.includes(String(line.id))} 
                      onChange={() => handleToggleSelectOne(line.id)} 
                    />
                  </td>
                  <td>{line.id}</td>
                  <td>{line.reference || 'N/A'}</td>
                  <td>{line.refFabricant || 'N/A'}</td>
                  <td>{line.quantity || 0}</td>
                  <td>
                    {line.achatLineId ? (
                      <span style={{ color: '#3498db' }}>AchatLine #{line.achatLineId}</span>
                    ) : (
                      <span style={{ color: '#95a5a6' }}>Inconnue</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showAttachModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', width: '600px', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <h2 style={{ marginTop: 0 }}>Attacher les lignes orphelines à un BCF</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              <strong>{selectedOrphanIds.length}</strong> ligne(s) sélectionnée(s). Choisissez le BCF de destination.
            </p>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>BCF de destination :</label>
              <select 
                value={String(selectedBcfId)} 
                onChange={(e) => setSelectedBcfId(e.target.value)} 
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              >
                {availableBcfs.map(bcf => (
                  <option key={bcf.id} value={String(bcf.id)}>
                    {bcf.reference || `BCF-${bcf.id}`} (ID: {bcf.id})
                  </option>
                ))}
              </select>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button className="boncomfournisseur-btn boncomfournisseur-btn-grey" onClick={() => setShowAttachModal(false)}>Annuler</button>
              <button className="boncomfournisseur-btn boncomfournisseur-btn-blue" onClick={handleConfirmAttach}>Confirmer l'attachement</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}